var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTotalFiles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Dashboard_-_Files",
    "data-name": "Dashboard - Files",
    transform: "translate(-680 -24)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_349",
    "data-name": "Ellipse 349",
    transform: "translate(680 24)",
    fill: "none",
    stroke: "#e3ebf1",
    strokeWidth: 1,
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 17.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "files-svgrepo-com",
    transform: "translate(687 30)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34166",
    "data-name": "Path 34166",
    d: "M15.5,2H8.6a1.606,1.606,0,0,0-1.1.5A1.606,1.606,0,0,0,7,3.6V16.4A1.721,1.721,0,0,0,8.6,18h9.8A1.721,1.721,0,0,0,20,16.4V6.5Z",
    fill: "none",
    stroke: "#3cc2e0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34167",
    "data-name": "Path 34167",
    d: "M3,7.6V20.4a1.606,1.606,0,0,0,.5,1.1,1.606,1.606,0,0,0,1.1.5h9.8",
    fill: "none",
    stroke: "#3cc2e0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34168",
    "data-name": "Path 34168",
    d: "M15,2V7h5",
    fill: "none",
    stroke: "#3cc2e0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalFiles);
export default __webpack_public_path__ + "static/media/totalFiles.de7f78307ac16731892ede3d25e8d4f0.svg";
export { ForwardRef as ReactComponent };